import clsx from "clsx";
import { IconProps } from "../../types/icons";
import { createColorClasses } from "@/theme/colors";

export const Cns = ({
  width = 24,
  height = 24,
  className,
  color,
  decorative = false,
  ariaLabel = "CNS",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
      className={clsx(className, classes)}
    >
      <path
        fill="#fff"
        d="M21.068 9.195h-8.902c-.22 0-.4.182-.4.405s.18.406.4.406h8.902c.22 0 .4-.182.4-.406a.403.403 0 0 0-.4-.405M21.068 12.148h-8.902c-.22 0-.4.19-.4.413a.41.41 0 0 0 .4.413h8.902c.22 0 .4-.19.4-.413a.41.41 0 0 0-.4-.413M21.068 15.129h-8.902c-.22 0-.4.182-.4.405s.18.405.4.405h8.902c.22 0 .4-.182.4-.405a.403.403 0 0 0-.4-.405M6.416 12.395c1.37 0 2.482-1.124 2.482-2.51s-1.111-2.51-2.482-2.51-2.482 1.124-2.482 2.51 1.11 2.51 2.482 2.51M10.195 14.064a3.2 3.2 0 0 0-.948-1.02 4.2 4.2 0 0 0-1.056-.528 3.107 3.107 0 0 1-3.55 0c-.39.132-.745.309-1.056.528-.4.281-.72.624-.947 1.02-.238.41-.372.869-.398 1.361a97 97 0 0 0-.005 1.073c0 .38.342.688.763.688h6.836c.421 0 .763-.308.763-.688 0-.01 0-.994-.005-1.072a3 3 0 0 0-.397-1.362"
      ></path>
      <path
        fill="#fff"
        d="M22.065 4.793H1.935A1.95 1.95 0 0 0 0 6.75v11.267c0 1.079.868 1.957 1.936 1.957h20.129A1.95 1.95 0 0 0 24 18.017V6.75c0-1.079-.868-1.957-1.936-1.957m1.179 13.224c0 .657-.53 1.192-1.18 1.192H1.936c-.65 0-1.18-.535-1.18-1.192V6.75c0-.658.53-1.192 1.18-1.192h20.129c.65 0 1.179.534 1.179 1.192z"
      ></path>
    </svg>
  );
};
